export const ADD_ALL_ITEMS_FULFILLED = 'waitrose/add-all-items/ADD_ALL_ITEMS_FULFILLED';
export const ADD_ALL_ITEMS_PENDING = 'waitrose/add-all-items/ADD_ALL_ITEMS_PENDING';
export const ADD_ALL_ITEMS_REJECTED = 'waitrose/add-all-items/ADD_ALL_ITEMS_REJECTED';
